import { useMutation } from '@tanstack/react-query';

import { userService } from '../services';

export const useUserTemporaryToken = () => {
  return useMutation({
    mutationFn: async () => {
      const response = await userService.getTemporaryToken();
      return response.data.data;
    },
  });
};
